import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestSsnComponent as TestSsnComponent } from './test-ssn.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  AgreementAreaModule,
  AirportModule,
  RadiobuttonBoxModule,
  SelectDateYmdModule,
  DateSelectorModule,
  ToggleModule,
  TabModule,
  SelectModule,
  CheckboxModule,
  ValidationErrorModule,
  InputModule,
} from '@lib/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GetBasicReservationInformationStoreServiceModule } from '@lib/services/get-basic-reservation-information-store/get-basic-reservation-information-store.module';
import { SubTestComponent } from './sub-test/sub-test.component';
import { StaticMsgModule } from '@lib/pipes';
import { TabTestComponent } from './tab-test/tab-test.component';
import { RouterModule } from '@angular/router';
import { MealApplicationModalModule } from '@app/id-modal/service-application/meal-application-modal/meal-application-modal.module';
import { ServiceApplicationTestComponent } from './testBlock/services-application/services-application-test.component';
import { BaggageApplicationModalModule, LoungeApplicationModalModule } from '@app/id-modal/service-application';
import {
  CreateCartStoreServiceModule,
  CurrentCartStoreServiceModule,
  CurrentPlanStoreServiceModule,
  DeliveryInformationStoreServiceModule,
  LocalPlanServiceModule,
  PlanReviewStoreServiceModule,
} from '@common/services';
import { bookingCompletedTestComponent } from './testBlock/booking-completed/booking-completed-test.component';
import { PassengerInformationRequestModule } from '@app/id-modal/passenger-information-request/passenger-information-request.module';
import { PassengerInformationRequestTestComponent } from './testBlock/passenger-information-request/passenger-information-request-test.component';
import { AgreementTestComponent } from './testBlock/agreement/agreement-test.component';
import { AgreementModule } from '@app/id-modal/agreement/agreement.module';
import { PlanReviewTestComponent } from './testBlock/plan-review/plan-review-test.component';
import { SeatmapTestComponent } from './testBlock/seatmap/seatmap-test.component';
import { SeatAttributeTestComponent } from './testBlock/seat-attribute-request/seat-attribute-request-test.component';
import { PetInputTestComponent } from './testBlock/pet-input/pet-input-test.component';
import { BizPaymentTestComponent } from './testBlock/biz-payment/biz-payment-test.component';
import { PaymentInputTestComponent } from './testBlock/payment-input/payment-input-test.component';

@NgModule({
  declarations: [
    TestSsnComponent,

    //テストページ
    SubTestComponent,
    TabTestComponent,
    ServiceApplicationTestComponent,
    bookingCompletedTestComponent,
    PassengerInformationRequestTestComponent,
    AgreementTestComponent,
    PlanReviewTestComponent,
    PetInputTestComponent,
    SeatmapTestComponent,
    SeatAttributeTestComponent,
    BizPaymentTestComponent,
    PaymentInputTestComponent,
  ],
  exports: [TestSsnComponent],
  imports: [
    RouterModule.forChild([{ path: '', component: TestSsnComponent }]),
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    AirportModule,
    DateSelectorModule,
    AgreementAreaModule,
    SelectDateYmdModule,
    RadiobuttonBoxModule,
    ToggleModule,
    TabModule,
    SelectModule,
    CheckboxModule,
    GetBasicReservationInformationStoreServiceModule,
    StaticMsgModule,
    LocalPlanServiceModule,
    DeliveryInformationStoreServiceModule,
    CreateCartStoreServiceModule,
    CurrentPlanStoreServiceModule,
    //テストページ
    CurrentCartStoreServiceModule,
    PlanReviewStoreServiceModule,
    LoungeApplicationModalModule,
    BaggageApplicationModalModule,
    MealApplicationModalModule,
    PassengerInformationRequestModule,
    AgreementModule,
    ValidationErrorModule,
    InputModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TestSsnModule {}
